<template>
  <div class="stock-apply-order">
    <!-- tab -->
    <ContentHeader
      path-set-type="append"
      :path-info="navPathInfo"
      :show-back="true"
    />

    <div class="content-container">
      <!-- 查询条件 -->
      <div class="query-panel">
        <el-form
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="订单编号">
                <el-input
                  v-model="queryParam.applyNumber"
                  placeholder="请输入订单编号"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品编码">
                <el-input
                  v-model="queryParam.itemCode"
                  placeholder="请输入商品编码"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在仓库">
                <el-select
                  v-model="queryParam.warehouseId"
                  placeholder="请选择仓库"
                  clearable
                >
                  <el-option
                    v-for="option in warehouseList"
                    :key="option.key"
                    :label="option.warehouseName"
                    :value="option.warehouseId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单状态">
                <el-select
                  v-model="queryParam.applyStatus"
                  placeholder="请选择订单状态"
                  clearable
                >
                  <el-option
                    v-for="option in applyStatusList"
                    :key="option.key"
                    :label="option.value"
                    :value="option.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否自提">
                <el-select
                  v-model="queryParam.isSelfDelivery"
                  placeholder="请选择是否自提"
                  clearable
                >
                  <el-option label="自提" value="1" />
                  <el-option label="非自提" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="查询日期">
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.fromDate"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="startTimeStatus"
                    :picker-options="pickerOptionsStart"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.toDate"
                    type="date"
                    placeholder="截止日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="endTimeStatus"
                    :picker-options="pickerOptionsEnd"
                  />
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-line">
          <el-button class="btn-blue-plain" @click="searchQuery" size="small"
            >查询</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
        </div>
      </div>
      <!-- 数据显示 -->
      <div class="table-show" :loading="loading">
        <el-table
          :data="stockOrderList"
          class="while-data-table"
          v-loading="loading"
        >
          <el-table-column
            prop="applyNumber"
            label="订单编号"
          ></el-table-column>

          <el-table-column label="订单时间">
            <template slot-scope="scope">
              {{ scope.row.applyDate | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="applyStatusName"
            label="订单状态"
          ></el-table-column>
          <el-table-column label="自提" width="50">
            <template slot-scope="scope">
              {{
                scope.row.isSelfDelivery === 1
                  ? "是"
                  : scope.row.isSelfDelivery === 0
                  ? "否"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="receivePerson"
            label="收货人"
            width="70"
          ></el-table-column>
          <el-table-column
            prop="receivePhone"
            label="联系电话"
          ></el-table-column>
          <el-table-column
            prop="applyRemark"
            label="备注"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            clign="center"
            label="操作"
            width="240"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleShow(scope.row)"
                  >查看</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  v-if="scope.row.applyStatus === 100"
                  @click="handleCancle(scope.row)"
                  >取消</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div>
        <el-row class="while-data-table-footer">
          <el-col>
            <el-pagination
              background
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContentHeader from '@/components/content-header'
export default {
  name: 'stock-apply-order',
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        applyNumber: '',
        itemCode: '',
        applyStatus: '',
        warehouseId: '',
        fromDate: '',
        toDate: '',
        isSelfDelivery: ''
      },
      total: 0,
      stockOrderList: [],
      warehouseList: [],
      pickerOptionsStart: {},
      pickerOptionsEnd: {}
    }
  },
  computed: {
    navPathInfo () {
      let pathInfo = { path: '/stock/apply', name: '物资申请' }
      return [pathInfo]
    },
    ...mapState({
      applyStatusList: state => state.base.stockApplyOrderStatusMap
    })
  },
  activated () {
    this.getApplyOrderList()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getDictByName', 'stockApplyOrderStatusMap')
      this.getWarehouseList()
      this.getApplyOrderList()
    },

    // 获取申请物资单列表
    getApplyOrderList () {
      this.loading = true
      this.$store
        .dispatch('getApplyOrderList', this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockOrderList = res.data.resultData.stockApplyList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 查看详情
    handleShow (row) {
      this.$router.push({
        path: '/stock/stock-apply-order/info',
        query: { applyId: row.applyId }
      })
    },

    // 取消
    handleCancle (row) {
      this.$confirm('是否确认取消该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store
            .dispatch('queryApplyOrderCancel', { applyId: row.applyId })
            .then(res => {
              if (res.data.resultCode === '0') {
                this.getApplyOrderList()
                this.$message.success('订单关闭成功')
              }
            })
            .catch(() => {
              this.$message.error('订单关闭失败')
            })
        })
        .catch(() => {})
    },

    // 查询
    searchQuery () {
      this.queryParam.page = 1
      this.getApplyOrderList()
    },

    // 重置
    resetQuery () {
      this.queryParam = this.$options.data().queryParam
      this.getApplyOrderList()
    },
    // 获取仓库列表
    getWarehouseList () {
      this.$store.dispatch('getWarehouseListAll').then(res => {
        this.warehouseList = res.data.resultData.warehouseList
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getApplyOrderList()
    },
    // 时间开始选择器
    startTimeStatus: function (value) {
      this.pickerOptionsEnd = {
        disabledDate: time => {
          let beginDateVal = this.queryParam.fromDate
          if (beginDateVal) {
            return (
              time.getTime() <= new Date(beginDateVal).getTime() - 86400000
            )
          }
        }
      }
    },
    // 时间结束选择器
    endTimeStatus: function (value) {
      this.pickerOptionsStart = {
        disabledDate: time => {
          let endDateVal = this.queryParam.fromDate
          if (endDateVal) {
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
